// The fiscal year a date falls in. No imports, so the web app can use it too.

/** Named by the year it ends: with a Dec 1 start, Dec 1, 2025 to Nov 30, 2026 is 2026. */
export function fiscalYearOf(date: string, fiscalYearStart: string): number {
  const year = Number(date.slice(0, 4));
  const start = fiscalYearStart.slice(5);
  if (start === '01-01') return year;
  return date.slice(5) >= start ? year + 1 : year;
}
